<template>
  <div v-if="warningMsg" class="cert-expiry-banner">
    <UIcon name="i-lucide-triangle-alert" class="size-4.5 shrink-0" />
    <span class="text-section-label min-w-0 leading-snug">{{ warningMsg }}</span>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { CertificateService } from 'app-core';

const warningMsg = ref<string | undefined>(undefined)

onMounted(async () => {
  const certInfo = await CertificateService.getInfo()
  warningMsg.value = certInfo.warningMsg
})
</script>

<style lang="scss" scoped>
// Same warning-banner language as MainLayout's training-banner (full-width,
// icon + text, error surface) — no dismiss action, this is a compliance
// notice, not a toggleable mode.
.cert-expiry-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  min-height: 44px;
  padding: 4px 12px 4px 16px;
  background: var(--ui-error);
  color: #ffffff;
}
</style>
